/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Tracked1Inputs */

const id_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dilacak:`)
};

const ms_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikesan:`)
};

const da_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sporret:`)
};

const de_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgt:`)
};

const en_us2_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracked:`)
};

const es_es2_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento:`)
};

const es_mx2_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreado`)
};

const fil_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-track:`)
};

const fr_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi :`)
};

const it_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciato:`)
};

const hu_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Követett:`)
};

const nl_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevolgd:`)
};

const no_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sporet:`)
};

const pl_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzone:`)
};

const pt_br2_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreado:`)
};

const pt_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registado:`)
};

const ro_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urmărit:`)
};

const fi_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seurattu:`)
};

const sv_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spårad:`)
};

const vi_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã theo dõi:`)
};

const tr_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzlenen:`)
};

const cs_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledováno:`)
};

const bg_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проследено:`)
};

const ru_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживается:`)
};

const uk_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відстежується:`)
};

const ar_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متعقب:`)
};

const hi_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक किया गया:`)
};

const th_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ที่ติดตาม:`)
};

const ja_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追跡中：`)
};

const zh_cn2_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已追踪：`)
};

const zh_hant1_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已追蹤：`)
};

const ko_components_performancetable_tracked1 = /** @type {(inputs: Components_Performancetable_Tracked1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추적:`)
};

/**
* | output |
* | --- |
* | "Tracked:" |
*
* @param {Components_Performancetable_Tracked1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_tracked1 = /** @type {((inputs?: Components_Performancetable_Tracked1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Tracked1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_tracked1(inputs)
	if (locale === "ms") return ms_components_performancetable_tracked1(inputs)
	if (locale === "da") return da_components_performancetable_tracked1(inputs)
	if (locale === "de") return de_components_performancetable_tracked1(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_tracked1(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_tracked1(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_tracked1(inputs)
	if (locale === "fil") return fil_components_performancetable_tracked1(inputs)
	if (locale === "fr") return fr_components_performancetable_tracked1(inputs)
	if (locale === "it") return it_components_performancetable_tracked1(inputs)
	if (locale === "hu") return hu_components_performancetable_tracked1(inputs)
	if (locale === "nl") return nl_components_performancetable_tracked1(inputs)
	if (locale === "no") return no_components_performancetable_tracked1(inputs)
	if (locale === "pl") return pl_components_performancetable_tracked1(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_tracked1(inputs)
	if (locale === "pt") return pt_components_performancetable_tracked1(inputs)
	if (locale === "ro") return ro_components_performancetable_tracked1(inputs)
	if (locale === "fi") return fi_components_performancetable_tracked1(inputs)
	if (locale === "sv") return sv_components_performancetable_tracked1(inputs)
	if (locale === "vi") return vi_components_performancetable_tracked1(inputs)
	if (locale === "tr") return tr_components_performancetable_tracked1(inputs)
	if (locale === "cs") return cs_components_performancetable_tracked1(inputs)
	if (locale === "bg") return bg_components_performancetable_tracked1(inputs)
	if (locale === "ru") return ru_components_performancetable_tracked1(inputs)
	if (locale === "uk") return uk_components_performancetable_tracked1(inputs)
	if (locale === "ar") return ar_components_performancetable_tracked1(inputs)
	if (locale === "hi") return hi_components_performancetable_tracked1(inputs)
	if (locale === "th") return th_components_performancetable_tracked1(inputs)
	if (locale === "ja") return ja_components_performancetable_tracked1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_tracked1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_tracked1(inputs)
	return ko_components_performancetable_tracked1(inputs)
});
export { components_performancetable_tracked1 as "components.performanceTable.tracked" }